import * as toastr from "toastr";
import { CalendarEvent } from "source/app/presentation/MainPanel/Calendar/CalendarEventUtils/CalendarEvent";
import { DeleteCalendarEventActionAsync } from "source/app/presentation/MainPanel/Calendar/CalendarEventDoneSwitch/DeleteEventLink/DeleteCalendarEventActionAsync";

export async function HandleFinishingCalendarEventAheadOfTimeAsync(
    calendarEvent: CalendarEvent
) {
    if (calendarEvent.HasNotStartedYet) {
        await DeleteCalendarEventActionAsync(calendarEvent.eventData);

        toastr.info(
            `Calendar event "${calendarEvent.eventData.name}" has been finished ahead of time and has been deleted`,
            ``,
            { timeOut: 1000 }
        );
    }
}
